import { useMutation } from 'react-query'
import hooks from '../../../hooks'

const useSeriesDelete = ({
    seriesId,
    onSuccess = () => {}
}) => {
    
    const cacheKeys = hooks.useCacheKeys()
    
    const { toastError, toastSuccess } = hooks.useToasts({ successMessage: 'Upcoming experiences deleted!', onSuccess })

    const { clearCache } = hooks.useCache({ key: cacheKeys.COURSES, onReload: toastSuccess })
    
    const { api, endpoints, url } = hooks.useApi()

    const [ deleteSeries, { isLoading }] = useMutation(
        () => api.delete(url(endpoints.series, { seriesId })),
        {
            onSuccess: clearCache,
            onError: toastError
        }
    )

    const { showConfirmation } = hooks.useConfirmationDialog({
        confirmLabel: 'Delete',
        title: 'Delete Series?',
        description: 'This will only delete future experiences.  Any experiences that have occurred will remain.',
        onConfirm: deleteSeries
    })

    return {
        deleteSeries: showConfirmation,
        isDeletingSeries: isLoading
    }
}

export default useSeriesDelete